module.exports = __webpack_public_path__ + "static/media/de.b2e74a5e.svg";